export default __webpack_public_path__ + "static/media/sponsor_eSemneaza.e864e347.png";